import { BlockConfig, zeroIOPS } from "../block-base";

export const textBoxConfig: BlockConfig = {
  displayName: "Text Box",
  imagePath: "",
  isInitiator: false,
  isTerminator: false,
  isInterceptor: false,
  allowedInputTypes: new Set(),
  allowedOutputTypes: new Set(),
  inputCapacity: zeroIOPS(),
  processingCapacity: zeroIOPS(),
  purchasePrice: 0,
  sellPrice: 0,
  costPerCycle: 0,
  outputConnectorLimits: {},
};
